export const galleryTagsPrefix = 'select_';
export const defaultTilesPerPage = 12;

export const GalleryTilesSorting = {
  ByDate: 'By Date',
  Unsorted: 'Unsorted',
} as const;

export const defaultTileSorting = GalleryTilesSorting.ByDate;
